/**
 * Phase 16 — Lieferanten lesen: entity_suppliers + merged Blob.
 */

import {
  listEntitySuppliers
} from '../infrastructure/storage/entityAggregateStore';
import { readBlobFirstWithAggregateFallback } from './canonicalEntityRead';
import { listAggregateSuppliers } from '../infrastructure/storage/domainAggregateStore';
import { readSyncWithBlobPriority, readArrayFieldFromMergedBlob } from './businessStateSync';

/** @type {Map<string, object[]>} */
const suppliersReadCache = new Map();

export function readSuppliersFromMergedBlob(businessId) {
  return readArrayFieldFromMergedBlob(businessId, 'suppliers', getCachedSuppliersRead);
}

export async function readSuppliersFromBestSource(businessId) {
  return readBlobFirstWithAggregateFallback(
    businessId,
    readSuppliersFromMergedBlob,
    listAggregateSuppliers,
    listEntitySuppliers,
    ['id', 'supplierId']
  );
}

export async function refreshSuppliersReadCache(businessId, preloaded) {
  const suppliers =
    preloaded !== undefined
      ? Array.isArray(preloaded)
        ? preloaded
        : []
      : await readSuppliersFromBestSource(businessId);
  if (businessId) {
    suppliersReadCache.set(String(businessId), suppliers);
  }
  return suppliers;
}

export function getCachedSuppliersRead(businessId) {
  if (!businessId) return null;
  return suppliersReadCache.get(String(businessId)) ?? null;
}

export function clearSuppliersReadCache(businessId) {
  if (businessId) {
    suppliersReadCache.delete(String(businessId));
  } else {
    suppliersReadCache.clear();
  }
}

export function seedSuppliersReadCache(businessId, suppliers) {
  if (!businessId || suppliers === undefined) return;
  suppliersReadCache.set(String(businessId), Array.isArray(suppliers) ? suppliers : []);
}

export function readSuppliersSyncForBusiness(businessId) {
  return readSyncWithBlobPriority(
    businessId,
    readSuppliersFromMergedBlob,
    getCachedSuppliersRead,
    'id',
    'supplierId'
  );
}
